var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"click-div pa-3",style:({'--baseClr': _vm.baseClr ? _vm.baseClr : _vm.defaultBase, '--hoverClr': _vm.hoverClr ? _vm.hoverClr : _vm.defaultHover}),on:{"click":_vm.newPage}},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }